<template>
    <i class="fas fa-spinner fa-pulse mr-1" v-if="loading"></i>
    <i class="fas fa-save fa-fw mr-1" aria-hidden="true" v-if="buttonClass.includes('save') && loading == false"></i>
    <i class="fas fa-trash fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('delete') && loading == false"></i>
    <i class="fas fa-edit fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('edit') && loading == false"></i>
    <i class="fas fa-plus fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('add') && loading == false"></i>
    <i class="fas fa-eye fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('show') && loading == false"></i>
    <i class="fas fa-download fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('download') && loading == false"></i>
    <i class="fas fa-filter fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('filter') && loading == false"></i>
    <i class="fas fa-chevron-left fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('previous') && loading == false"></i>
    <i class="fas fa-check fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('approve') && loading == false"></i>
    <i class="fas fa-paper-plane fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('send') && loading == false"></i>
    <i class="fas fa-list-alt fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('details') && loading == false"></i>
    <i class="fas fa-search fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('search') && loading == false"></i>
    <i class="fas fa-sign-out-alt fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('logout') && loading == false"></i>
    <i class="fas fa-sign-in-alt fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('login') && loading == false"></i>
    <i class="fas fa-cog fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('settings') && loading == false"></i>
    <i class="fas fa-sync-alt fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('refresh') && loading == false"></i>
    <i class="fas fa-redo-alt fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('redo') && loading == false"></i>
    <i class="fas fa-times fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('cancel') && loading == false"></i>
    <i class="fas fa-comment fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('comment') && loading == false"></i>
    <i class="fas fa-info fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('info') && loading == false"></i>
    <i class="fas fa-print fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('print') && loading == false"></i>
    <i class="fas fa-ban fa-fw mr-1" aria-hidden="true" v-else-if="buttonClass.includes('block') && loading == false"></i>
    {{ text }}
    <i class="fas fa-chevron-right fa-fw mr-1" aria-hidden="true" v-if="buttonClass.includes('next') && loading == false"></i>
</template>

<script>

export default {
    props: {
        text: {
            type: String,
        },
        buttonClass: {
            type: String,
            default: 'primary',//primary, secondary, default, info, alt, danger, success, save, delete, edit, show, ...
        },
        loading: {
            type: Boolean,
            default: false
        },
    },
}
</script>

